var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEnhancements(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 532.8 516.4",
    style: {
      enableBackground: "new 0 0 532.8 516.4"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2_00000044145343495214449430000017797381991300008352_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "285.9,516.4 289.4,512.8 394.3,257.2 489.5,202.8 532.8,65 364.6,67.6 312.2,0 285.9,0  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "43.3,202.8 138.5,257.2 235.5,512.3 239.9,515.8 239.9,0 214.3,0 166.1,67.6 0,65  "
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnhancements);
export default __webpack_public_path__ + "static/media/enhancements.b72f19bde9a0682e83c3bf91f5d2d162.svg";
export { ForwardRef as ReactComponent };